/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 11:54:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useToggleState } from "ui-widgets";
import { InviteWorkersDialog } from "./InviteWorkersDialog";

export const InviteWorkersButtonWrapper = ({ children }) => {
  const { open, handleClose, handleOpen } = useToggleState();

  return (
    <>
      {React.Children.map(children, (child) => React.cloneElement(child, { onClick: handleOpen }))}{" "}
      <InviteWorkersDialog open={open} handleClose={handleClose} />
    </>
  );
};
